import { Dispatch, ActionCreator } from "redux";
import { ThunkAction } from "redux-thunk";

import {
  AllPatientDispatchTypes,
  AllPatientTabDispatchTypes,
  EligibilityCheckActionDispatchTypes,
  Icd10RecordDispatchTypes,
  MyPatientDispatchTypes,
  ReauthReferralRequestActionDispatchTypes,
  ReauthReferralSubmitActionDispatchTypes,
  ReferralSubmitDispatchTypes,
  PatientRequestDispatchTypes,
  UpdateMyPatientListDispatchTypes,
  ServiceRequestIsRetroDispatchTypes,
} from "../models/DispatchTypes/AllPatientRecord";
import {
  AssignStaffIncompletePatientDispatchTypes,
  IncompletePatientDispatchTypes,
} from "../models/DispatchTypes/Patient";
import {
  AssignStaffIncompletePatientActionDispatchTypes,
  IncompletePatientActionDispatchTypes,
} from "../constants/Patient";
import {
  AssignedStaff,
  AssignStaffIncompleteRequest,
  ReAuthReferralRequest,
  GetPostPutIcd10Records,
} from "../models/Patient";
import {
  ReAuthServiceRequest,
  ServiceProviderPayload,
} from "./../models/Service";
import {
  EligibilityCheckDispatchTypes,
  Icd10RecordsActionDispatchTypes,
  MessageType,
  MyPatientActionDispatchTypes,
  MyPatientListActionDispatchTypes,
  PatientRecordDispatchTypes,
  PatientTabDispatchTypes,
  ReAuthReferralRequestDispatchType,
  ReAuthReferralSubmitDispatchTypes,
  ReferralResponseMessages,
  ReferralSubmitActionDispatchTypes,
  PatientRequestActionDispatchTypes,
  ServiceRequestIsRetroActionDispatchTypes,
} from "../constants/AllPatientRecord";
import {
  PostCheckEligibility,
  DeleteDocumentsFile,
  PostAllPatientRecord,
  GetDocumentDownload,
  GetDocuments,
  GetExcelDownload,
  GetIcd10Records,
  PostIncompletePatientList,
  PostMyPatientList,
  GetPatientRequestById,
  GetPatientTab,
  GetReauthReferralRequestById,
  PostReauthReferralSubmit,
  GetReferralDocuments,
  PostReferralSubmit,
  GetServiceRequestRecords,
  PutIncompletePatientList,
  PutMyPatientList,
  PostDocumentsDetail,
  SaveDocumentsFile,
  PostIcd10RecordsData,
  PostPatientRequest,
  PostReauthReferralRequest,
  SaveReauthServiceRequest as ReAuthServiceRequestService,
  PutDocumentsDetail,
  PutDocumentsFile,
  PutICD10,
  PutPatientRequestById,
  PutReauthReferralRequest,
  UpdateReauthServiceRequest,
  PostGenerateAuthTemplate,
  PostAttachLetter,
  PostResendFax,
  GetServiceRequestIsRetro,
  PostResendEmail,
} from "../services/AllPatientRecord";
import {
  configUrlForBlob,
  configUrlForCheckEligibility,
  configUrlForReferral,
  configUrlForUserManagement,
} from "../constants/Config";
import {
  ReAuthPhysicianDetailsDispatchTypes,
  ReferralIntakePhysicianDetailsDispatchTypes,
} from "../models/DispatchTypes/PhysicianDetails";
import {
  GetFollowingPhysicianDetailsActionDispatchTypes,
  GetPhysicianRecordsActionDispatchTypes,
  PostFollowingPhysicianDetailsActionDispatchTypes,
  PutFollowingPhysicianDetailsActionDispatchTypes,
  PhysicianDetailsActionDispatchTypes,
} from "../constants/PhysicianDetails";
import {
  GetFollowingPhysicianDetailsCall,
  GetPhysicianDetails,
  GetPhysicianRecords,
  PostFollowingPhysicianDetailsCall,
  PostPhysicianDetails,
  PutFollowingPhysicianDetailsCall,
  PutPhysicianDetails,
} from "../services/PhysicianDetails";
import {
  DocumentDownloadDispatchTypes,
  DocumentReviewActionDispatchTypes,
  ExcelDownloadDispatchTypes,
  GenerateAuthTemplateDispatchTypes,
  ReferralDocumentFileDispatchTypes,
  DocumentDetailActionDispatchTypes,
  AttachLetterActionDispatchTypes,
  ResendFaxFileActionDispatchTypes,
  ResendEmailActionDispatchTypes,
} from "../constants/Document";
import {
  AttachLetterDispatchTypes,
  DocumentDownloadActionDispatchTypes,
  DocumentReviewDispatchTypes,
  ExcelDownloadActionDispatchTypes,
  GenerateAuthTemplateActionDispatchTypes,
  ReferralDocumentFileActionDispatchTypes,
  ResendEmailDispatchTypes,
  ResendFaxFileDispatchTypes,
} from "../models/DispatchTypes/Document";
import {
  ReAuthServiceRequestActionDispatchType,
  ServiceRequestActionDispatchType,
  ServiceProviderActionDispatchType
} from "../constants/Service";
import {
  PostServiceRequest,
  PutServiceRequest,
  GetServiceProviderById,
  PostServiceProviderDetails,
  PutServiceProvider,
} from "../services/Service";
import { PatientTabModule, ReauthTabModule } from "../routes/AllRoutes";
import { ReferralIntakePhysicianDetails } from "../models/PhysicianDetails";
import SnackbarUtils from "../utils/SnackbarProvider";
import { ServiceProviderDetailDispatchTypes } from "../models/DispatchTypes/Service";
import { DispatchResponse, get404InitialData, getValue } from "../utils";
import {
  MyPatientResponse,
  ReAuthSubmitPayload,
  ReferralSubmitPayload,
} from "../models/Api/AllPatientRecord";
import { resetStates } from "./Common";
import { DocumentPayload, ResendFaxPayload } from "../models/Document";
import { ApplicationState } from "../store/ApplicationState";

export const postAllPatientRecord: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    AllPatientDispatchTypes
  >
> = (payload: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: PatientRecordDispatchTypes.POST_PATIENT_RECORD_INVOKE,
    });

    const response = await PostAllPatientRecord(configUrlForReferral, payload);

    dispatch({
      response: response,
      type: PatientRecordDispatchTypes.POST_PATIENT_RECORD_SUCCESS,
    });
  };
};

export const getPatientTabList: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    AllPatientTabDispatchTypes>
> = (path?: string) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: PatientTabDispatchTypes.GET_PATIENT_TAB_INVOKE,
    });
    const response = GetPatientTab(path);
    dispatch({
      response,
      type: PatientTabDispatchTypes.GET_PATIENT_TAB_SUCCESS,
    });
  };
};

export const getPatientRequestById: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    PatientRequestDispatchTypes>
> = (referralId: string, patientId: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: PatientRequestActionDispatchTypes.GET_PATIENT_REQUEST_INVOKE,
    });
    const response = await GetPatientRequestById(
      configUrlForReferral,
      referralId,
      patientId
    );
    dispatch({
      response,
      type: PatientRequestActionDispatchTypes.GET_PATIENT_REQUEST_SUCCESS,
    });
  };
};

export const getICd10Records: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    Icd10RecordDispatchTypes
  >
> = (id: number, typeId: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: Icd10RecordsActionDispatchTypes.GET_POST_PUT_ICD_10_INVOKE,
    });
    const response = await GetIcd10Records(configUrlForReferral, id, typeId);
    dispatch({
      response,
      type: Icd10RecordsActionDispatchTypes.GET_POST_PUT_ICD_10_SUCCESS,
    });
  };
};

export const updateReferralDetail: ActionCreator<
  ThunkAction<void, ApplicationState, Record<string, never>, any>
> = (payload: any, activeTab: number) => {
  return async (dispatch: Dispatch) => {
    await updateDispatch(payload, activeTab, dispatch);
  };
};

export const updateReauthReferralDetail: ActionCreator<
  ThunkAction<void, ApplicationState, Record<string, never>, any>
> = (payload: any, activeTab: number) => {
  return async (dispatch: Dispatch) => {
    await putReauthDispatch(payload, activeTab, dispatch);
  };
};

export const updateDispatch = (
  payload: any,
  activeTab: number,
  dispatch: Dispatch
) => {
  switch (activeTab) {
    case PatientTabModule.REQUEST:
      return putReferralRequest(payload, dispatch);
    case PatientTabModule.ICD10:
      return putICD10(payload, dispatch);
    case PatientTabModule.ORDERING_PHYSICIAN:
      return putPhysicianDetails(
        getValue(payload, "orderingPhysician.referralId", ""),
        payload,
        dispatch
      );
    case PatientTabModule.SERVICE_PROVIDER:
      return putServiceProvider(payload, dispatch);
    case PatientTabModule.SERVICE_REQUEST:
      return putServiceRequest(payload, dispatch);
    case PatientTabModule.DOCUMENTS:
      return putDocument(payload, dispatch);
    case PatientTabModule.REVIEW:
      return "";
  }
  return "";
};

export const putReauthDispatch = (
  payload: any,
  activeTab: number,
  dispatch: Dispatch
) => {
  switch (activeTab) {
    case ReauthTabModule.REQUEST:
      return putReauthRequest(payload, dispatch);
    case ReauthTabModule.ICD10:
      return putICD10(payload, dispatch);
    case ReauthTabModule.FOLLOWING_PHYSICIAN:
      return putFollowingPhysicianDetails(
        payload.serviceRequestId,
        payload,
        dispatch
      );
    case ReauthTabModule.SERVICE_REQUEST:
      return UpdateReauthServiceRequestRecord(payload, dispatch);
    case ReauthTabModule.DOCUMENTS:
      return putDocument(payload, dispatch);
    case ReauthTabModule.REVIEW:
      return "";
  }
  return "";
};

const putReferralRequest = async (payload: any, dispatch: Dispatch) => {
  dispatch({
    type: PatientRequestActionDispatchTypes.POST_PUT_PATIENT_REQUEST_INVOKE,
  });
  const response = await PutPatientRequestById(
    configUrlForReferral,
    payload
  );
  if (response && response.status) {
    switch (response.status) {
      case 422:
      case 400:
        dispatch({
          response,
          type: PatientRequestActionDispatchTypes.POST_PUT_PATIENT_REQUEST_ERROR,
        });
        break;
      case 200:
      case 201:
        dispatch({
          response: response.data,
          type: PatientRequestActionDispatchTypes.POST_PUT_PATIENT_REQUEST_SUCCESS,
        });
        SnackbarUtils.success(
          ReferralResponseMessages(MessageType.UPDATE_REFERRAL_DATA)
        );
        break;
      default:
        break;
    }
  }
};

const putServiceRequest = async (payload: any, dispatch: Dispatch) => {
  dispatch({
    type: ServiceRequestActionDispatchType.POST_PUT_SERVICE_REQUEST_INVOKE,
  });

  const response = await PutServiceRequest(configUrlForReferral, payload);

  if (response && response.status) {
    switch (response.status) {
      case 422:
      case 400:
        dispatch({
          response,
          type: ServiceRequestActionDispatchType.POST_PUT_SERVICE_REQUEST_ERROR,
        });
        break;
      case 200:
      case 201:
        dispatch({
          response: response.data,
          type: ServiceRequestActionDispatchType.POST_PUT_SERVICE_REQUEST_SUCCESS,
        });
        SnackbarUtils.success(
          ReferralResponseMessages(MessageType.UPDATE_SERVICE_REQUEST)
        );
        break;
      default:
        break;
    }
  }
};
export const getServiceProviderById: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ServiceProviderDetailDispatchTypes>
> = (referralId: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ServiceProviderActionDispatchType.GET_SERVICE_PROVIDER_DETAIL_INVOKE,
    });
    const response = await GetServiceProviderById(
      configUrlForReferral,
      referralId
    );
    dispatch({
      response,
      type: ServiceProviderActionDispatchType.GET_SERVICE_PROVIDER_DETAIL_SUCCESS,
    });
  };
};

export const postServiceProviderDetails = async (
  payload: ServiceProviderPayload,
  dispatch: Dispatch
) => {
  dispatch({
    type: ServiceProviderActionDispatchType.POST_PUT_SERVICE_PROVIDER_INVOKE,
  });
  const response = await PostServiceProviderDetails(
    configUrlForReferral,
    payload
  );

  if (response && response.status) {
    switch (response.status) {
      case 422:
      case 400:
        dispatch({
          response,
          type: ServiceProviderActionDispatchType.POST_PUT_SERVICE_PROVIDER_ERROR,
        });
        break;
      case 200:
      case 201:
        dispatch({
          response: response.data,
          type: ServiceProviderActionDispatchType.POST_PUT_SERVICE_PROVIDER_SUCCESS,
        });
        SnackbarUtils.success(
          ReferralResponseMessages(MessageType.SAVE_SERVICE_PROVIDER_DATA)
        );
        break;
      default:
        break;
    }
  }
};

export const putServiceProvider = async (
  payload: ServiceProviderPayload,
  dispatch: Dispatch
) => {
  dispatch({
    type: ServiceProviderActionDispatchType.POST_PUT_SERVICE_PROVIDER_INVOKE,
  });
  const suffix = `/${payload.referralId}`;
  const response = await PutServiceProvider(
    configUrlForReferral,
    suffix,
    payload
  );

  if (response && response.status) {
    switch (response.status) {
      case 422:
      case 400:
        dispatch({
          response,
          type: ServiceProviderActionDispatchType.POST_PUT_SERVICE_PROVIDER_ERROR,
        });
        break;
      case 200:
      case 201:
        dispatch({
          response: response.data,
          type: ServiceProviderActionDispatchType.POST_PUT_SERVICE_PROVIDER_SUCCESS,
        });

        SnackbarUtils.success(
          ReferralResponseMessages(MessageType.UPDATE_SERVICE_PROVIDER_DATA)
        );
        break;
      default:
        break;
    }
  }
};

export const postICd10RecordsCall = async (
  payload: GetPostPutIcd10Records,
  dispatch: Dispatch
) => {
  dispatch({
    type: Icd10RecordsActionDispatchTypes.GET_POST_PUT_ICD_10_INVOKE,
  });
  const response = await PostIcd10RecordsData(configUrlForReferral, payload);

  if (response && response.status) {
    DispatchResponse(
      dispatch,
      response,
      Icd10RecordsActionDispatchTypes.GET_POST_PUT_ICD_10_ERROR,
      Icd10RecordsActionDispatchTypes.GET_POST_PUT_ICD_10_SUCCESS,
      MessageType.SAVE_ICD10_DATA
    );
  }
};

export const putICD10 = async (
  payload: GetPostPutIcd10Records,
  dispatch: Dispatch
) => {
  dispatch({
    type: Icd10RecordsActionDispatchTypes.GET_POST_PUT_ICD_10_INVOKE,
  });
  const response = await PutICD10(configUrlForReferral, payload);

  if (response && response.status) {
    DispatchResponse(
      dispatch,
      response,
      Icd10RecordsActionDispatchTypes.GET_POST_PUT_ICD_10_ERROR,
      Icd10RecordsActionDispatchTypes.GET_POST_PUT_ICD_10_SUCCESS,
      MessageType.UPDATE_ICD10_DATA
    );
  }
};

export const saveReferralDetail: ActionCreator<
  ThunkAction<void, ApplicationState, Record<string, never>, any>
> = (payload: any, activeTab: number) => {
  return async (dispatch: Dispatch) => {
    await saveDispatch(payload, activeTab, dispatch);
  };
};

export const referralIntakeReset: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    PatientRequestDispatchTypes>
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: PatientRequestActionDispatchTypes.POST_PUT_PATIENT_REQUEST_RESET,
    });
  };
};

export const saveReauthReferralDetail: ActionCreator<
  ThunkAction<void, ApplicationState, Record<string, never>, any>
> = (payload: any, activeTab: number) => {
  return async (dispatch: Dispatch) => {
    await postReauthDispatch(payload, activeTab, dispatch);
  };
};

export const putFollowingPhysicianDetails = async (
  reAuthId: number,
  data: ReferralIntakePhysicianDetails,
  dispatch: Dispatch
) => {
  dispatch({
    type: PutFollowingPhysicianDetailsActionDispatchTypes.PUT_FOLLOWING_PHYSICIAN_DETAILS_INVOKE,
  });
  const suffix = `${reAuthId}`;
  const response = await PutFollowingPhysicianDetailsCall(
    configUrlForReferral,
    suffix,
    data
  );

  switch (response.status) {
    case 422:
    case 400:
      dispatch({
        response,
        type: PutFollowingPhysicianDetailsActionDispatchTypes.PUT_FOLLOWING_PHYSICIAN_DETAILS_ERROR,
      });
      break;
    case 200:
    case 201:
      dispatch({
        response: response.data,
        type: PutFollowingPhysicianDetailsActionDispatchTypes.PUT_FOLLOWING_PHYSICIAN_DETAILS_SUCCESS,
      });
      SnackbarUtils.success(
        ReferralResponseMessages(MessageType.UPDATE_FOLLOWING_PHYSICIAN_DETAILS)
      );
      break;
    default:
      break;
  }
};

export const postFollowingPhysicianDetails = async (
  data: ReferralIntakePhysicianDetails,
  dispatch: Dispatch
) => {
  dispatch({
    type: PostFollowingPhysicianDetailsActionDispatchTypes.POST_FOLLOWING_PHYSICIAN_DETAILS_INVOKE,
  });

  const response = await PostFollowingPhysicianDetailsCall(
    configUrlForReferral,
    data
  );

  switch (response.status) {
    case 422:
    case 400:
      dispatch({
        response,
        type: PostFollowingPhysicianDetailsActionDispatchTypes.POST_FOLLOWING_PHYSICIAN_DETAILS_ERROR,
      });
      break;
    case 200:
    case 201:
      dispatch({
        response: response.data,
        type: PostFollowingPhysicianDetailsActionDispatchTypes.POST_FOLLOWING_PHYSICIAN_DETAILS_SUCCESS,
      });
      SnackbarUtils.success(
        ReferralResponseMessages(MessageType.SAVE_FOLLOWING_PHYSICIAN_DETAILS)
      );
      break;
    default:
      break;
  }
};

export const saveDispatch = (
  payload: any,
  activeTab: number,
  dispatch: Dispatch
) => {
  switch (activeTab) {
    case PatientTabModule.REQUEST:
      return postPatientRequestDetail(payload, dispatch);
    case PatientTabModule.ICD10:
      return postICd10RecordsCall(payload, dispatch);
    case PatientTabModule.ORDERING_PHYSICIAN:
      return postPhysicianDetails(payload, dispatch);
    case PatientTabModule.SERVICE_PROVIDER:
      return postServiceProviderDetails(payload, dispatch);
    case PatientTabModule.SERVICE_REQUEST:
      return postServiceRequest(payload, dispatch);
    case PatientTabModule.DOCUMENTS:
      return postDocument(payload, dispatch);
    case PatientTabModule.REVIEW:
      return "";
  }
  return "";
};

export const postReauthDispatch = (
  payload: any,
  activeTab: number,
  dispatch: Dispatch
) => {
  switch (activeTab) {
    case ReauthTabModule.REQUEST:
      return postReauthRequest(payload, dispatch);
    case ReauthTabModule.ICD10:
      return postICd10RecordsCall(payload, dispatch);
    case ReauthTabModule.FOLLOWING_PHYSICIAN:
      return postFollowingPhysicianDetails(payload, dispatch);
    case ReauthTabModule.SERVICE_REQUEST:
      return SaveReAuthServiceRequest(payload, dispatch);
    case ReauthTabModule.DOCUMENTS:
      return postDocument(payload, dispatch);
    case ReauthTabModule.REVIEW:
      return "";
  }
  return "";
};

const postPatientRequestDetail = async (payload: any, dispatch: Dispatch) => {
  dispatch({
    type: PatientRequestActionDispatchTypes.POST_PUT_PATIENT_REQUEST_INVOKE,
  });
  const response = await PostPatientRequest(configUrlForReferral, payload);

  if (response && response.status) {
    switch (response.status) {
      case 422:
      case 400:
        dispatch({
          response,
          type: PatientRequestActionDispatchTypes.POST_PUT_PATIENT_REQUEST_ERROR,
        });
        break;
      case 200:
      case 201:
        dispatch({
          response: response.data,
          type: PatientRequestActionDispatchTypes.POST_PUT_PATIENT_REQUEST_SUCCESS,
        });
        SnackbarUtils.success(
          ReferralResponseMessages(MessageType.SAVE_REFERRAL_DATA)
        );
        break;
      default:
        break;
    }
  }
};

const postServiceRequest = async (payload: any, dispatch: Dispatch) => {
  dispatch({
    type: ServiceRequestActionDispatchType.POST_PUT_SERVICE_REQUEST_INVOKE,
  });
  const response = await PostServiceRequest(configUrlForReferral, payload);

  if (response && response.status) {
    switch (response.status) {
      case 422:
      case 400:
        dispatch({
          response,
          type: ServiceRequestActionDispatchType.POST_PUT_SERVICE_REQUEST_ERROR,
        });
        break;
      case 200:
      case 201:
        dispatch({
          response: response.data,
          type: ServiceRequestActionDispatchType.POST_PUT_SERVICE_REQUEST_SUCCESS,
        });
        SnackbarUtils.success(
          ReferralResponseMessages(MessageType.SAVE_SERVICE_REQUEST)
        );
        break;
      default:
        break;
    }
  }
};
const SaveReAuthServiceRequest = async (payload: any, dispatch: Dispatch) => {
  // copy same for Reauth. and update
  dispatch({
    type: ServiceRequestActionDispatchType.POST_PUT_SERVICE_REQUEST_INVOKE,
  });
  const response = await ReAuthServiceRequestService(
    configUrlForReferral,
    payload
  ); //configUrl for workflow url to pass from here

  if (response && response.status) {
    switch (response.status) {
      case 422:
      case 400:
        dispatch({
          response,
          type: ReAuthServiceRequestActionDispatchType.RE_AUTH_SERVICE_REQUEST_ERROR,
        });
        break;
      case 200:
      case 201:
        dispatch({
          response: response.data,
          type: ReAuthServiceRequestActionDispatchType.RE_AUTH_SERVICE_REQUEST_SUCCESS,
        });
        SnackbarUtils.success(
          ReferralResponseMessages(MessageType.SAVE_SERVICE_REQUEST)
        );
        break;
      default:
        break;
    }
  }
};

// Referral Intake Physician details new wireframe

export const getPhysicianRecords: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ReferralIntakePhysicianDetailsDispatchTypes
  >
> = (value: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: GetPhysicianRecordsActionDispatchTypes.GET_PHYSICIAN_RECORDS_INVOKE,
    });

    const suffix = `?searchText=${value}`;

    const response = await GetPhysicianRecords(configUrlForReferral, suffix);

    dispatch({
      response,
      type: GetPhysicianRecordsActionDispatchTypes.GET_PHYSICIAN_RECORDS_SUCCESS,
    });
  };
};

export const resetPhysicianRecords = () => {
  return resetStates([
    GetPhysicianRecordsActionDispatchTypes.RESET_PHYSICIAN_RECORDS,
  ]);
};

const putPhysicianDetails = async (
  referralId: string,
  payload: ReferralIntakePhysicianDetails,
  dispatch: Dispatch
) => {
  dispatch({
    type: PhysicianDetailsActionDispatchTypes.PUT_PHYSICIAN_DETAILS_INVOKE,
  });
  const suffix = `/${referralId}`;
  const response = await PutPhysicianDetails(
    configUrlForReferral,
    suffix,
    payload
  );

  if (response && response.status) {
    switch (response.status) {
      case 422:
      case 400:
        dispatch({
          response,
          type: PhysicianDetailsActionDispatchTypes.PUT_PHYSICIAN_DETAILS_ERROR,
        });
        break;
      case 200:
      case 201:
        dispatch({
          response: response.data,
          type: PhysicianDetailsActionDispatchTypes.PUT_PHYSICIAN_DETAILS_SUCCESS,
        });
        SnackbarUtils.success(
          ReferralResponseMessages(MessageType.UPDATE_PHYSICIAN_DATA)
        );
        break;
      default:
        break;
    }
  }
};

export const postPhysicianDetails = async (
  payload: any,
  dispatch: Dispatch
) => {
  dispatch({
    type: PhysicianDetailsActionDispatchTypes.POST_PHYSICIAN_DETAILS_INVOKE,
  });
  const response = await PostPhysicianDetails(configUrlForReferral, payload);

  if (response && response.status) {
    switch (response.status) {
      case 422:
      case 400:
        dispatch({
          response,
          type: PhysicianDetailsActionDispatchTypes.POST_PHYSICIAN_DETAILS_ERROR,
        });
        break;
      case 200:
      case 201:
        dispatch({
          response: response.data,
          type: PhysicianDetailsActionDispatchTypes.POST_PHYSICIAN_DETAILS_SUCCESS,
        });
        SnackbarUtils.success(
          ReferralResponseMessages(MessageType.SAVE_PHYSICIAN_DATA)
        );
        break;
      default:
        break;
    }
  }
};

export const getPhysicianDetails: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ReferralIntakePhysicianDetailsDispatchTypes
  >
> = (referralId: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: PhysicianDetailsActionDispatchTypes.GET_PHYSICIAN_DETAILS_INVOKE,
    });
    const suffix = `/${referralId}`;
    const response = await GetPhysicianDetails(configUrlForReferral, suffix);
    dispatch({
      response,
      type: PhysicianDetailsActionDispatchTypes.GET_PHYSICIAN_DETAILS_SUCCESS,
    });
  };
};

export const getFollowingPhysicianDetails: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ReAuthPhysicianDetailsDispatchTypes
  >
> = (reAuthId: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: GetFollowingPhysicianDetailsActionDispatchTypes.GET_FOLLOWING_PHYSICIAN_DETAILS_INVOKE,
    });

    const response = await GetFollowingPhysicianDetailsCall(
      configUrlForReferral,
      reAuthId
    );

    dispatch({
      response,
      type: GetFollowingPhysicianDetailsActionDispatchTypes.GET_FOLLOWING_PHYSICIAN_DETAILS_SUCCESS,
    });
  };
};
export const getDocuments: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    DocumentReviewDispatchTypes
  >
> = (id: string, type: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: DocumentReviewActionDispatchTypes.DOCUMENT_REVIEW_INVOKE,
    });

    const response = await GetDocuments(configUrlForReferral, id, type);

    dispatch({
      response,
      type: DocumentReviewActionDispatchTypes.DOCUMENT_REVIEW_SUCCESS,
    });
  };
};

export const getReauthRequestById: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ReauthReferralRequestActionDispatchTypes>
> = (reAuthId: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ReAuthReferralRequestDispatchType.GET_POST_PUT_RE_AUTH_REFERRAL_REQUEST_INVOKE,
    });
    const response = await GetReauthReferralRequestById(
      configUrlForReferral,
      reAuthId
    );
    dispatch({
      response,
      type: ReAuthReferralRequestDispatchType.GET_POST_PUT_RE_AUTH_REFERRAL_REQUEST_SUCCESS,
    });
  };
};

export const postReferralSubmit: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ReferralSubmitDispatchTypes>
> = (payload: ReferralSubmitPayload, referralIntakeDetails?: boolean) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ReferralSubmitActionDispatchTypes.POST_REFERRAL_SUBMIT_INVOKE,
    });
    const response = await PostReferralSubmit(configUrlForReferral, payload);

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
          dispatch({
            response,
            type: ReferralSubmitActionDispatchTypes.POST_REFERRAL_SUBMIT_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: ReferralSubmitActionDispatchTypes.POST_REFERRAL_SUBMIT_SUCCESS,
          });
          if (referralIntakeDetails) {
            SnackbarUtils.success(
              ReferralResponseMessages(MessageType.SAVE_REFERRAL_INTAKE_DETAILS)
            );
          } else {
            SnackbarUtils.success(
              ReferralResponseMessages(MessageType.SAVE_AUTH_DETAILS)
            );
          }
          break;
        default:
          break;
      }
    }
  };
};

const putDocument = async (payload: any, dispatch: Dispatch) => {
  dispatch({
    type: DocumentDetailActionDispatchTypes.POST_PUT_DOCUMENT_DETAIL_INVOKE,
  });
  const response = await PutDocumentsDetail(configUrlForReferral, payload);
  if (response && response.status) {
    switch (response.status) {
      case 422:
      case 400:
        dispatch({
          response,
          type: DocumentDetailActionDispatchTypes.POST_PUT_DOCUMENT_DETAIL_ERROR,
        });
        break;
      case 200:
      case 201:
        dispatch({
          response: response.data,
          type: DocumentDetailActionDispatchTypes.POST_PUT_DOCUMENT_DETAIL_SUCCESS,
        });
        SnackbarUtils.success(
          ReferralResponseMessages(MessageType.UPDATE_DOCUMENT_DATA)
        );
        break;
      default:
        break;
    }
  }
};

const postDocument = async (payload: any, dispatch: Dispatch) => {
  dispatch({
    type: DocumentDetailActionDispatchTypes.POST_PUT_DOCUMENT_DETAIL_INVOKE,
  });
  const response = await PostDocumentsDetail(configUrlForReferral, payload);

  if (response && response.status) {
    switch (response.status) {
      case 422:
      case 400:
        dispatch({
          response,
          type: DocumentDetailActionDispatchTypes.POST_PUT_DOCUMENT_DETAIL_ERROR,
        });
        break;
      case 200:
      case 201:
        dispatch({
          response: response.data,
          type: DocumentDetailActionDispatchTypes.POST_PUT_DOCUMENT_DETAIL_SUCCESS,
        });
        SnackbarUtils.success(
          ReferralResponseMessages(MessageType.SAVE_DOCUMENT_DATA)
        );
        break;
      default:
        break;
    }
  }
};

export const getReferralDocuments: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ReferralDocumentFileActionDispatchTypes
  >
> = (payload: DocumentPayload) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ReferralDocumentFileDispatchTypes.PUT_REFERRAL_DOCUMENT_INVOKE,
    });

    const response = await GetReferralDocuments(configUrlForReferral, payload);

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
          dispatch({
            response,
            type: ReferralDocumentFileDispatchTypes.PUT_REFERRAL_DOCUMENT_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: ReferralDocumentFileDispatchTypes.PUT_REFERRAL_DOCUMENT_SUCCESS,
          });
          break;
        case 404:
          dispatch({
            response: [],
            type: ReferralDocumentFileDispatchTypes.PUT_REFERRAL_DOCUMENT_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const putDocumentFile: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ReferralDocumentFileActionDispatchTypes>
> = (payload: any, referralId: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ReferralDocumentFileDispatchTypes.PUT_REFERRAL_DOCUMENT_INVOKE,
    });
    const response = await PutDocumentsFile(
      configUrlForReferral,
      payload,
      referralId
    );

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
          dispatch({
            response,
            type: ReferralDocumentFileDispatchTypes.PUT_REFERRAL_DOCUMENT_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: ReferralDocumentFileDispatchTypes.PUT_REFERRAL_DOCUMENT_SUCCESS,
          });
          SnackbarUtils.success(
            ReferralResponseMessages(MessageType.UPDATE_DOCUMENT_FILE)
          );
          break;
        default:
          break;
      }
    }
  };
};

export const saveDocumentFile: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ReferralDocumentFileActionDispatchTypes>
> = (payload: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ReferralDocumentFileDispatchTypes.PUT_REFERRAL_DOCUMENT_INVOKE,
    });
    const response = await SaveDocumentsFile(configUrlForReferral, payload);

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
          dispatch({
            response,
            type: ReferralDocumentFileDispatchTypes.PUT_REFERRAL_DOCUMENT_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: getValue(response, "data.length") === 0 ? true : response.data,
            type: ReferralDocumentFileDispatchTypes.PUT_REFERRAL_DOCUMENT_SUCCESS,
          });
          if (getValue(response, "data.length") === 0) {
            SnackbarUtils.success(
              ReferralResponseMessages(MessageType.SAVE_DOCUMENT_FILE)
            );
          }
          break;
        default:
          break;
      }
    }
  };
};

export const deleteDocumentFile: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ReferralDocumentFileActionDispatchTypes
  >
> = (blobId: any, userDeleted: string, referralBlobId: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ReferralDocumentFileDispatchTypes.PUT_REFERRAL_DOCUMENT_INVOKE,
    });
    const response = await DeleteDocumentsFile(
      configUrlForReferral,
      blobId,
      userDeleted,
      referralBlobId
    );
    dispatch({
      response,
      type: ReferralDocumentFileDispatchTypes.PUT_REFERRAL_DOCUMENT_SUCCESS,
    });
    if (response) {
      SnackbarUtils.success(
        ReferralResponseMessages(MessageType.DELETE_DOCUMENT_FILE)
      );
    }
  };
};

export const postReauthRequest = async (
  payload: ReAuthReferralRequest,
  dispatch: Dispatch
) => {
  dispatch({
    type: ReAuthReferralRequestDispatchType.GET_POST_PUT_RE_AUTH_REFERRAL_REQUEST_INVOKE,
  });
  const response = await PostReauthReferralRequest(
    configUrlForReferral,
    payload
  );

  if (response && response.status) {
    switch (response.status) {
      case 422:
      case 400:
        dispatch({
          response,
          type: ReAuthReferralRequestDispatchType.GET_POST_PUT_RE_AUTH_REFERRAL_REQUEST_ERROR,
        });
        break;
      case 200:
      case 201:
        dispatch({
          response: response.data,
          type: ReAuthReferralRequestDispatchType.GET_POST_PUT_RE_AUTH_REFERRAL_REQUEST_SUCCESS,
        });
        SnackbarUtils.success(
          ReferralResponseMessages(MessageType.SAVE_REFERRAL_DATA)
        );
        break;
      default:
        break;
    }
  }
};

const putReauthRequest = async (
  payload: ReAuthReferralRequest,
  dispatch: Dispatch
) => {
  dispatch({
    type: ReAuthReferralRequestDispatchType.GET_POST_PUT_RE_AUTH_REFERRAL_REQUEST_INVOKE,
  });
  const response = await PutReauthReferralRequest(
    configUrlForReferral,
    payload
  );

  if (response && response.status) {
    switch (response.status) {
      case 422:
      case 400:
        dispatch({
          response,
          type: ReAuthReferralRequestDispatchType.GET_POST_PUT_RE_AUTH_REFERRAL_REQUEST_ERROR,
        });
        break;
      case 200:
      case 201:
        dispatch({
          response: response.data,
          type: ReAuthReferralRequestDispatchType.GET_POST_PUT_RE_AUTH_REFERRAL_REQUEST_SUCCESS,
        });
        SnackbarUtils.success(
          ReferralResponseMessages(MessageType.UPDATE_REFERRAL_DATA)
        );
        break;
      default:
        break;
    }
  }
};

export const getReauthServiceRequestsRecords: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    Icd10RecordDispatchTypes
  >
> = (reAuthId: number, startOfCareDate?: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ReAuthServiceRequestActionDispatchType.RE_AUTH_SERVICE_REQUEST_INVOKE,
    });
    const response = await GetServiceRequestRecords(
      configUrlForReferral,
      reAuthId,
      startOfCareDate
    );
    dispatch({
      response,
      type: ReAuthServiceRequestActionDispatchType.RE_AUTH_SERVICE_REQUEST_SUCCESS,
    });
  };
};

const UpdateReauthServiceRequestRecord = async (
  payload: ReAuthServiceRequest,
  dispatch: Dispatch
) => {
  dispatch({
    type: ReAuthServiceRequestActionDispatchType.RE_AUTH_SERVICE_REQUEST_INVOKE,
  });
  const response = await UpdateReauthServiceRequest(
    configUrlForReferral,
    payload
  );

  if (response && response.status) {
    switch (response.status) {
      case 422:
      case 400:
        dispatch({
          response,
          type: ReAuthServiceRequestActionDispatchType.RE_AUTH_SERVICE_REQUEST_ERROR,
        });
        break;
      case 200:
      case 201:
        dispatch({
          response: response.data,
          type: ReAuthServiceRequestActionDispatchType.RE_AUTH_SERVICE_REQUEST_SUCCESS,
        });
        SnackbarUtils.success(
          ReferralResponseMessages(MessageType.UPDATE_SERVICE_REQUEST)
        );
        break;
      default:
        break;
    }
  }
};
//
export const PutMyPatientListRecord: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    UpdateMyPatientListDispatchTypes>
> = (assignedToStaffId: number, payload: AssignedStaff) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: MyPatientListActionDispatchTypes.MY_PATIENT_LIST_INVOKE,
    });
    const response = await PutMyPatientList(
      configUrlForReferral,
      assignedToStaffId,
      payload
    );

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
          dispatch({
            error: response.data,
            type: MyPatientListActionDispatchTypes.MY_PATIENT_LIST_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: MyPatientListActionDispatchTypes.MY_PATIENT_LIST_SUCCESS,
          });
          SnackbarUtils.success(
            ReferralResponseMessages(MessageType.UPDATE_ASSIGN_STAFF_REQUEST)
          );
          break;
        default:
          break;
      }
    }
  };
};

export const PutIncompletePatientListRecord: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    AssignStaffIncompletePatientDispatchTypes>
> = (assignedUserId: number, payload: AssignStaffIncompleteRequest) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: AssignStaffIncompletePatientActionDispatchTypes.ASSIGN_STAFF_INCOMPLETE_PATIENT_INVOKE,
    });

    const response = await PutIncompletePatientList(
      configUrlForReferral,
      assignedUserId,
      payload
    );

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
          dispatch({
            error: response.data,
            type: AssignStaffIncompletePatientActionDispatchTypes.ASSIGN_STAFF_INCOMPLETE_PATIENT_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: AssignStaffIncompletePatientActionDispatchTypes.ASSIGN_STAFF_INCOMPLETE_PATIENT_SUCCESS,
          });
          SnackbarUtils.success(
            ReferralResponseMessages(MessageType.UPDATE_INCOMPLETE_REQUEST)
          );
          break;
        default:
          break;
      }
    }
  };
};

export const postReauthReferralSubmit: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ReauthReferralSubmitActionDispatchTypes>
> = (reAuthId: string, payload: ReAuthSubmitPayload) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ReAuthReferralSubmitDispatchTypes.POST_RE_AUTH_REFERRAL_SUBMIT_INVOKE,
    });
    const response = await PostReauthReferralSubmit(
      configUrlForReferral,
      reAuthId,
      payload
    );
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
          dispatch({
            response,
            type: ReAuthReferralSubmitDispatchTypes.POST_RE_AUTH_REFERRAL_SUBMIT_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: ReAuthReferralSubmitDispatchTypes.POST_RE_AUTH_REFERRAL_SUBMIT_SUCCESS,
          });
          SnackbarUtils.success(
            ReferralResponseMessages(MessageType.REAUTH_DETAILS_SUCCESS)
          );
          break;
        default:
          break;
      }
    }
  };
};
export const postReauthReferralSubmitReset: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ReauthReferralSubmitActionDispatchTypes>
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ReAuthReferralSubmitDispatchTypes.POST_RE_AUTH_REFERRAL_SUBMIT_RESET,
    });
  };
};

export const postCheckEligibility: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    EligibilityCheckActionDispatchTypes
  >
> = (payload: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: EligibilityCheckDispatchTypes.POST_CHECK_ELIGIBILITY_INVOKE,
    });
    const response = await PostCheckEligibility(
      configUrlForCheckEligibility,
      payload
    );

    if (response && response.status) {
      switch (response.status) {
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: EligibilityCheckDispatchTypes.POST_CHECK_ELIGIBILITY_SUCCESS,
          });
          break;
        case 422:
        case 400:
        default:
          dispatch({
            response,
            type: EligibilityCheckDispatchTypes.POST_CHECK_ELIGIBILITY_ERROR,
          });
          break;
      }
    }
  };
};

export const eligibilityReset: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    EligibilityCheckActionDispatchTypes>
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: EligibilityCheckDispatchTypes.POST_CHECK_ELIGIBILITY_RESET,
    });
  };
};

const initialState: MyPatientResponse = {
  loading: false,
  response: {
    totalRows: -1,
    searchResponse: [],
  },
};
export const postMyPatientList: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    MyPatientDispatchTypes
  >
> = (payload: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: MyPatientActionDispatchTypes.POST_PATIENT_LIST_INVOKE,
    });
    const response = get404InitialData(
      await PostMyPatientList(configUrlForReferral, payload),
      initialState
    );
    dispatch({
      response: response.data,
      type: MyPatientActionDispatchTypes.POST_PATIENT_LIST_SUCCESS,
    });
  };
};

export const postIncompletePatientList: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    IncompletePatientDispatchTypes
  >
> = (payload: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: IncompletePatientActionDispatchTypes.POST_INCOMPLETE_PATIENT_INVOKE,
    });
    const response = get404InitialData(
      await PostIncompletePatientList(configUrlForReferral, payload),
      initialState
    );
    dispatch({
      response: response.data,
      type: IncompletePatientActionDispatchTypes.POST_INCOMPLETE_PATIENT_SUCCESS,
    });
  };
};

export const documentDownload: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    DocumentDownloadActionDispatchTypes>
> = (blobId: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: DocumentDownloadDispatchTypes.GET_DOCUMENT_DOWNLOAD_INVOKE,
    });

    const response = await GetDocumentDownload(
      configUrlForBlob,
      blobId,
      "file"
    );

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500: 
        case 404:
          dispatch({
            response,
            type: DocumentDownloadDispatchTypes.GET_DOCUMENT_DOWNLOAD_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: {
              blob: response.data,
              headers: response.headers,
            },
            type: DocumentDownloadDispatchTypes.GET_DOCUMENT_DOWNLOAD_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const excelDownload: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ExcelDownloadActionDispatchTypes>
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ExcelDownloadDispatchTypes.EXCEL_DOWNLOAD_INVOKE,
    });
    const response = await GetExcelDownload(
      configUrlForUserManagement,
      "ExcelFile",
      "excel"
    );
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          dispatch({
            response,
            type: ExcelDownloadDispatchTypes.EXCEL_DOWNLOAD_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: ExcelDownloadDispatchTypes.EXCEL_DOWNLOAD_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const excelDownloadReset: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ExcelDownloadActionDispatchTypes>
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ExcelDownloadDispatchTypes.EXCEL_DOWNLOAD_RESET,
    });
  };
};

export const postGenerateAuthTemplate: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    GenerateAuthTemplateActionDispatchTypes
  >
> = (referralId: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: GenerateAuthTemplateDispatchTypes.POST_GENERATE_AUTH_TEMPLATE_INVOKE,
    });

    const response = await PostGenerateAuthTemplate(
      configUrlForReferral,
      referralId
    );
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
          dispatch({
            response,
            type: GenerateAuthTemplateDispatchTypes.POST_GENERATE_AUTH_TEMPLATE_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: GenerateAuthTemplateDispatchTypes.POST_GENERATE_AUTH_TEMPLATE_SUCCESS,
          });
          SnackbarUtils.success(
            ReferralResponseMessages(MessageType.AUTH_TEMPLATE_GENERATE_SUCCESS)
          );
          break;
        default:
          break;
      }
    }
  };
};

export const postAttachLetter: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    AttachLetterDispatchTypes>
> = (payload: FormData) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: AttachLetterActionDispatchTypes.POST_ATTACH_LETTER_INVOKE,
    });
    const response = await PostAttachLetter(configUrlForReferral, payload);

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
          dispatch({
            response,
            type: AttachLetterActionDispatchTypes.POST_ATTACH_LETTER_ERROR,
          });
          SnackbarUtils.error(
            ReferralResponseMessages(MessageType.POST_ATTACH_LETTER_ERROR)
          );
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: AttachLetterActionDispatchTypes.POST_ATTACH_LETTER_SUCCESS,
          });
          SnackbarUtils.success(
            ReferralResponseMessages(MessageType.SAVE_ATTACH_LETTER)
          );
          break;
        default:
          break;
      }
    }
  };
};

export const resendFax: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ResendFaxFileDispatchTypes
  >
> = (payload: ResendFaxPayload) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ResendFaxFileActionDispatchTypes.POST_RESEND_FAX_INVOKE,
    });

    const response = await PostResendFax(configUrlForReferral, payload);

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
          dispatch({
            response,
            type: ResendFaxFileActionDispatchTypes.POST_RESEND_FAX_ERROR,
          });
          SnackbarUtils.error(
            ReferralResponseMessages(MessageType.POST_RESEND_FAX_ERROR)
          );
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: ResendFaxFileActionDispatchTypes.POST_RESEND_FAX_SUCCESS,
          });
          SnackbarUtils.success(
            ReferralResponseMessages(MessageType.POST_RESEND_FAX_SUCCESS)
          );
          break;
        default:
          break;
      }
    }
  };
};

export const resendEmail: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ResendEmailDispatchTypes
  >
> = (notificationEmailParameterId: number | null) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ResendEmailActionDispatchTypes.POST_RESEND_EMAIL_INVOKE,
    });

    const response = await PostResendEmail(configUrlForReferral, notificationEmailParameterId);

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
          dispatch({
            response,
            type: ResendEmailActionDispatchTypes.POST_RESEND_EMAIL_ERROR,
          });
          SnackbarUtils.error(
            ReferralResponseMessages(MessageType.POST_RESEND_FAX_ERROR)
          );
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: ResendEmailActionDispatchTypes.POST_RESEND_EMAIL_SUCCESS,
          });
          SnackbarUtils.success(
            ReferralResponseMessages(MessageType.POST_RESEND_FAX_SUCCESS)
          );
          break;
        default:
          break;
      }
    }
  };
};

export const getServiceRequestIsRetro: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ServiceRequestIsRetroDispatchTypes
  >
> = (socDate: string, payload: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ServiceRequestIsRetroActionDispatchTypes.GET_SERVICE_REQUEST_IS_RETRO_INVOKE,
    });
    const response = await GetServiceRequestIsRetro(
      configUrlForReferral,
      socDate,
      payload
    );
    dispatch({
      response,
      type: ServiceRequestIsRetroActionDispatchTypes.GET_SERVICE_REQUEST_IS_RETRO_SUCCESS,
    });
  };
};
